/** @jsx jsx */
import { jsx } from "theme-ui"

/*
 * Generic file-type icons for download buttons (DEV-745).
 *
 * Paths from Lucide (lucide-static v1.47.0): file, file-text, file-spreadsheet,
 * file-chart-column, file-archive. https://lucide.dev
 *
 * ISC License — Copyright (c) for portions of Lucide are held by Cole Bemis
 * 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are
 * held by Lucide Contributors 2025. Permission to use, copy, modify, and/or
 * distribute this software for any purpose with or without fee is hereby
 * granted, provided that the above copyright notice and this permission notice
 * appear in all copies.
 *
 * Lucide icons are strokes, not fills. The Button passes style={{fill}} to every
 * icon; it is deliberately NOT forwarded here, because an inline fill would
 * override fill="none" and turn the outline into a solid shape. Size and color
 * come from the Button's icon wrapper (1em, currentColor).
 */

const PAGE =
  "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z"
const FOLD = "M14 2v5a1 1 0 0 0 1 1h5"

const GLYPHS = {
  file: [<path key="p" d={PAGE} />, <path key="f" d={FOLD} />],
  fileText: [
    <path key="p" d={PAGE} />,
    <path key="f" d={FOLD} />,
    <path key="1" d="M10 9H8" />,
    <path key="2" d="M16 13H8" />,
    <path key="3" d="M16 17H8" />,
  ],
  fileSpreadsheet: [
    <path key="p" d={PAGE} />,
    <path key="f" d={FOLD} />,
    <path key="1" d="M8 13h2" />,
    <path key="2" d="M14 13h2" />,
    <path key="3" d="M8 17h2" />,
    <path key="4" d="M14 17h2" />,
  ],
  fileChart: [
    <path key="p" d={PAGE} />,
    <path key="f" d={FOLD} />,
    <path key="1" d="M8 18v-1" />,
    <path key="2" d="M12 18v-6" />,
    <path key="3" d="M16 18v-3" />,
  ],
  fileArchive: [
    <path
      key="p"
      d="M13.659 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v11.5"
    />,
    <path key="f" d={FOLD} />,
    <path key="1" d="M8 12v-1" />,
    <path key="2" d="M8 18v-2" />,
    <path key="3" d="M8 7V6" />,
    <circle key="c" cx="8" cy="20" r="2" />,
  ],
}

export const FILE_ICON_NAMES = Object.keys(GLYPHS)

const FileTypeIcon = ({ name }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {GLYPHS[name] || GLYPHS.file}
  </svg>
)

export default FileTypeIcon
